
import { useState, useEffect } from "react";
import "./ClientForm.css";

export default function ClientForm({ onSubmit, client }) {
  const initialForm = {
    nom: "",
    telephone: "",
    email: "",
    adresse: "",
  };

  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (client) {
      setForm({
        nom: client.nom || "",
        telephone: client.telephone || "",
        email: client.email || "",
        adresse: client.adresse || "",
      });
    } else {
      setForm(initialForm);
    }
  }, [client]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.nom.trim()) {
      alert("Le nom du client est obligatoire.");
      return;
    }

    try {
      setLoading(true);

      await onSubmit({
        nom: form.nom.trim(),
        telephone: form.telephone.trim(),
        email: form.email.trim(),
        adresse: form.adresse.trim(),
      });

      setForm(initialForm);
    } catch (error) {
      console.error("Erreur formulaire client :", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form className="client-form" onSubmit={handleSubmit}>

      <div className="client-form-title">
        {client ? "Modifier le client" : "Ajouter un client"}
      </div>

      <div className="client-form-grid">

        <div className="form-group">
          <label htmlFor="nom">
            Nom <span>*</span>
          </label>

          <input
            id="nom"
            name="nom"
            type="text"
            placeholder="Nom du client"
            value={form.nom}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="telephone">
            Téléphone
          </label>

          <input
            id="telephone"
            name="telephone"
            type="tel"
            placeholder="Téléphone"
            value={form.telephone}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">
            Email
          </label>

          <input
            id="email"
            name="email"
            type="email"
            placeholder="Adresse email"
            value={form.email}
            onChange={handleChange}
          />
        </div>

        <div className="form-group">
          <label htmlFor="adresse">
            Adresse
          </label>

          <input
            id="adresse"
            name="adresse"
            type="text"
            placeholder="Adresse du client"
            value={form.adresse}
            onChange={handleChange}
          />
        </div>

      </div>

      <div className="client-form-actions">
        <button
          type="submit"
          className="btn-save-client"
          disabled={loading}
        >
          {loading
            ? "Enregistrement..."
            : client
              ? "Modifier le client"
              : "Enregistrer le client"}
        </button>
      </div>

    </form>
  );
}

